import React from "react";
import './Team.css';
import LandingNav from '../Navigation/LandingNav';
import Footer from '../Navigation/Footer';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
    
function Team(){

    const {t,i18n} = useTranslation("team")
    function handleClick(newLang) {
    
    }
    
    return(

        <div>

            <LandingNav onClick={handleClick} />
            {/* <LandingNav onClick={handleClick} state={{language: language}} /> */}

             {/* Team Section */}


             <div className='team-container'>

                <div className='team-heading'>

                    <h2 className='team-title'>  {t("title")} </h2>
                    <p className='team-subtitle'> {t("subTitle")}</p>

                </div>

                <div className='team-section'>




                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberOne.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberOne.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberTwo.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberTwo.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberThree.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberThree.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberFour.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberFour.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberFive.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberFive.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberSix.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberSix.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberSeven.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberSeven.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberEight.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberEight.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberOne.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberOne.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberOne.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberOne.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberNine.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberNine.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberTen.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberTen.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberEleven.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberOne.description")}
                        </p>
                    </div>

                    <div class="team-card">
                        {/* <img class="member-img" loading='lazy' src="/assets/images/TEAM-IMAGES/stock1.png" alt="Team Image"></img> */}
                
                        <h4 class="member-name"> {t("memberOne.title")}  </h4>
                        {/* <p className='member-role'>  {t("memberOne.title")}  </p> */}
                        {/* <a href="#">
                            <img class="linkden-logo" loading='lazy' src="/assets/images/TEAM-IMAGES/linkden-icon.png" alt="Linkden Logo"></img>
                        </a> */}
                        <p class="member-comment">
                            {t("memberEleven.description")}
                        </p>
                    </div>


            {/*  End of team section */}
            </div>
            <div className="extras"> 
                <p className='project-desc-text'>

                    {t("benefit")}
                    <br/><br/>
                    
                    <ul>
                        <li>{t("extra1")}</li> 
                        <li>{t("extra2")}</li>
                        <li>{t("extra3")}</li>
                        <li>{t("extra4")}</li>
                        <li>{t("extra5")}</li>
                        <li>{t("extra6")}</li>
                        <li>{t("extra7")}</li>
                        <li>{t("extra8")}</li>  
                        <li>{t("extra9")}</li>
                        <li>{t("extra10")}</li>
                        <li>{t("extra11")}</li>
                        <li>{t("extra12")}</li>
                    </ul>
                </p>
            </div>

        {/* End of team container */}
        </div>












            <Footer/>

        </div>


    )







}

export default Team;
  